import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { LoginPayload, RegisterState } from "../../types";

import { apiRequest, handleAuth } from "../../utils/data"
import { AppDispatch } from "../../store";


const initialState: RegisterState = {
    loading: false,
    error: null,
    success: false,
}
export const loginUser = createAsyncThunk('auth/login', async ({ data, navigate, dispatch }: { data: LoginPayload, navigate: any, dispatch: AppDispatch }) => {
    const res= handleAuth("Authentication/login", data, navigate, dispatch)
    return res;
})
export const updateFirebaseToken = createAsyncThunk('auth/updateFirebaseToken', async (data: any) => {
    try {
        const response = await apiRequest("Authentication/updateFirebaseToken", {
            method: "PUT",
            body: data,
            auth: true
        });
        return response
    } catch (error: any) {
        console.log(error)
    }
})

const loginSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        resetLoginState: (state) => {
            state.loading = false;
            state.error = null;
            state.success = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(loginUser.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
            })
            .addCase(loginUser.fulfilled, (state) => {
                state.success = true;
                state.loading = false;
            })
            .addCase(loginUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });

    }
});

export const { resetLoginState } = loginSlice.actions;
export default loginSlice.reducer;